import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.market.listings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type Seller = {
    name: string;
    company: string;
    office_name: string;
    phone: string;
    email: string;
};

type RightInfo = {
    right_type: string;
    category: string;
    field: string;
    right_title: string;
    owner_name: string;
    application_number: string;
    application_date: string;
    registration_number: string;
    registration_date: string;
};

type SaleFile = {
    id: string;
    file_name: string;
    file_type: string;
    mime_type: string;
    size_bytes: number;
    created_at: string;
    download_url?: string;
};

type SaleRequestDetail = {
    id: string;
    reference: string;
    source: 'IP_MARKET_PORTAL';
    status: string;
    seller: Seller;
    right: RightInfo;
    desired_price: number | null;
    sale_method: string;
    privacy_consent: boolean;
    fee_consent: boolean;
    admin_service_requested: boolean;
    assigned_to: string | null;
    description: string;
    files: SaleFile[];
    submitted_at: string;
    updated_at: string;
};

type ListingItem = {
    id: string;
    sale_request_id: string;
    title: string;
    right_type: string;
    application_number: string;
    registration_number: string;
    asking_price: number | null;
    publication_status: string;
    transaction_status: string;
    public_seller_label: string;
    updated_at: string;
};

type ListingDetail = ListingItem & {
    source_request: SaleRequestDetail;
};

type ListingEditDraft = {
    seller: Seller;
    right: RightInfo;
    desired_price: number | null;
    sale_method: string;
    privacy_consent: boolean;
    fee_consent: boolean;
    admin_service_requested: boolean;
    description: string;
};

type Pagination = {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
};

@Component({
    selector: 'wiz-page-ip-market-listings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.market.listings/view.scss */
:host {
  display: block;
  height: 100%;
}

.listing-detail-summary {
  position: sticky;
  z-index: 4;
  top: 3rem;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(22rem, 29rem);
  gap: 1rem;
  align-items: stretch;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #dbe4ea;
  background: radial-gradient(circle at 100% 0, rgba(8, 145, 178, 0.08), transparent 20rem), rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(10px);
}

.listing-detail-summary__main {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.listing-detail-summary__copy {
  min-width: 0;
}

.listing-detail-summary__id {
  overflow: hidden;
  max-width: 24rem;
  color: #94a3b8;
  font-size: 0.65rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-detail-summary h2 {
  margin-top: 0.55rem;
  overflow: hidden;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-detail-summary p {
  margin-top: 0.25rem;
  color: #64748b;
  font-size: 0.68rem;
}

.listing-detail-summary__actions {
  display: flex;
  flex: 0 0 auto;
  gap: 0.5rem;
}

.listing-edit-button {
  display: inline-flex;
  height: 2.25rem;
  align-items: center;
  gap: 0.4rem;
  padding: 0 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.55rem;
  color: #334155;
  background: #fff;
  font-size: 0.7rem;
  font-weight: 750;
  transition: border-color 140ms ease, color 140ms ease, background-color 140ms ease;
}

.listing-edit-button:hover {
  border-color: #67e8f9;
  color: #0e7490;
  background: #ecfeff;
}

.listing-edit-button:disabled {
  opacity: 0.5;
}

.listing-detail-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: #f8fafc;
}

.listing-status-card,
.listing-info-card,
.listing-seller-card,
.listing-edit-card,
.listing-attachments-card {
  border: 1px solid #dbe4ea;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.035);
}

.listing-status-card {
  padding: 1rem;
  border-color: #bae6fd;
  background: linear-gradient(145deg, #fff, #f0f9ff);
}

.listing-status-card--header {
  padding: 0.75rem;
  box-shadow: none;
}

.listing-status-card__heading {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.listing-status-card__icon,
.listing-seller-card__icon,
.listing-metric__icon,
.listing-file-icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}

.listing-status-card__icon {
  width: 2rem;
  height: 2rem;
  border-radius: 0.55rem;
  color: #0e7490;
  background: #cffafe;
  font-size: 0.75rem;
}

.listing-status-card__heading h3,
.listing-section-heading h3,
.listing-seller-card__heading h3,
.listing-attachments-card__heading h3 {
  color: #0f172a;
  font-size: 0.82rem;
  font-weight: 800;
}

.listing-status-card__heading p,
.listing-section-heading > div > p:last-child,
.listing-seller-card__heading p,
.listing-attachments-card__heading p {
  margin-top: 0.18rem;
  color: #64748b;
  font-size: 0.64rem;
  line-height: 1rem;
}

.listing-status-card__controls {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.55rem;
  margin-top: 0.85rem;
}

.listing-status-card__note {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-top: 0.7rem;
  color: #64748b;
  font-size: 0.65rem;
  line-height: 1rem;
}

.listing-status-card__note i {
  margin-top: 0.1rem;
  color: #0891b2;
}

.listing-info-card,
.listing-edit-card {
  padding: 1rem;
}

.listing-section-heading,
.listing-seller-card__heading,
.listing-attachments-card__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.listing-section-heading__eyebrow {
  color: #0891b2;
  font-size: 0.56rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.listing-metric-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
  margin-top: 1rem;
}

.listing-metric {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.65rem;
  padding: 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
  background: #f8fafc;
}

.listing-metric__icon {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 0.6rem;
  color: #0e7490;
  background: #cffafe;
  font-size: 0.72rem;
}

.listing-metric__icon--emerald {
  color: #047857;
  background: #d1fae5;
}

.listing-metric__icon--indigo {
  color: #4338ca;
  background: #e0e7ff;
}

.listing-metric span {
  display: block;
  color: #94a3b8;
  font-size: 0.62rem;
}

.listing-metric strong {
  display: block;
  overflow: hidden;
  margin-top: 0.18rem;
  color: #1e293b;
  font-size: 0.76rem;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.listing-fact-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  margin-top: 1rem;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
}

.listing-fact-grid > div {
  min-width: 0;
  padding: 0.8rem 0.9rem;
  border-bottom: 1px solid #e2e8f0;
}

.listing-fact-grid > div:nth-child(odd) {
  border-right: 1px solid #e2e8f0;
}

.listing-fact-grid > div:nth-last-child(-n+2) {
  border-bottom: 0;
}

.listing-fact-grid dt,
.listing-seller-grid dt {
  color: #94a3b8;
  font-size: 0.62rem;
}

.listing-fact-grid dd,
.listing-seller-grid dd {
  overflow-wrap: anywhere;
  margin-top: 0.22rem;
  color: #334155;
  font-size: 0.74rem;
  font-weight: 650;
}

.listing-description {
  margin-top: 1rem;
}

.listing-description h4 {
  color: #475569;
  font-size: 0.7rem;
  font-weight: 750;
}

.listing-description p {
  min-height: 4.5rem;
  margin-top: 0.45rem;
  padding: 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  color: #475569;
  background: #f8fafc;
  font-size: 0.74rem;
  line-height: 1.4rem;
  white-space: pre-wrap;
}

.listing-seller-card {
  padding: 1rem;
  border-color: #fde68a;
  background: linear-gradient(145deg, #fff, #fffbeb);
}

.listing-seller-card__heading {
  justify-content: flex-start;
}

.listing-seller-card__heading > span {
  margin-left: auto;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  color: #92400e;
  background: #fef3c7;
  font-size: 0.58rem;
  font-weight: 800;
}

.listing-seller-card__icon {
  width: 2rem;
  height: 2rem;
  border-radius: 0.55rem;
  color: #92400e;
  background: #fef3c7;
  font-size: 0.7rem;
}

.listing-seller-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.7rem;
  margin-top: 0.9rem;
}

.listing-seller-grid > div {
  min-width: 0;
  padding: 0.75rem;
  border: 1px solid #fde68a;
  border-radius: 0.6rem;
  background: rgba(255, 255, 255, 0.78);
}

.listing-edit-form {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 1rem;
}

.listing-edit-seller {
  padding: 0.9rem;
  border: 1px solid #fde68a;
  border-radius: 0.7rem;
  background: #fffbeb;
}

.listing-attachments-card {
  overflow: hidden;
}

.listing-attachments-card__heading {
  padding: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.listing-file-count {
  color: #64748b;
  font-size: 0.65rem;
  font-weight: 700;
}

.listing-file-empty {
  display: flex;
  min-height: 7.5rem;
  margin: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cbd5e1;
  border-radius: 0.7rem;
  color: #94a3b8;
  background: #f8fafc;
  text-align: center;
}

.listing-file-empty i {
  font-size: 1.1rem;
}

.listing-file-empty p {
  margin-top: 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
}

.listing-file-empty span {
  margin-top: 0.2rem;
  font-size: 0.6rem;
}

.listing-file-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem;
  padding: 1rem;
}

.listing-file-list li {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.8rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  background: #f8fafc;
}

.listing-file-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 0.55rem;
  color: #0e7490;
  background: #cffafe;
  font-size: 0.7rem;
}

@media (max-width: 720px) {
  .listing-detail-summary {
    position: static;
    grid-template-columns: minmax(0, 1fr);
  }
  .listing-detail-summary__main {
    align-items: stretch;
    flex-direction: column;
  }
  .listing-detail-summary__actions {
    align-self: flex-end;
  }
  .listing-status-card__controls,
  .listing-metric-grid,
  .listing-fact-grid,
  .listing-seller-grid,
  .listing-file-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .listing-fact-grid > div:nth-child(odd) {
    border-right: 0;
  }
  .listing-fact-grid > div:nth-last-child(-n+2) {
    border-bottom: 1px solid #e2e8f0;
  }
  .listing-fact-grid > div:last-child {
    border-bottom: 0;
  }
}`],
})
export class PageIpMarketListingsComponent implements OnInit {
    public items: ListingItem[] = [];
    public selected: ListingDetail | null = null;
    public editDraft: ListingEditDraft = this.emptyDraft();
    public filters: any = {
        q: '',
        publication_status: '',
        right_type: '',
        page: 1,
        limit: 50
    };
    public publicationStatuses: string[] = ['PUBLISHED', 'SUSPENDED', 'ENDED'];
    public statusDraft: string = '';
    public statusSaving: boolean = false;
    public rightTypes: string[] = ['PATENT', 'UTILITY_MODEL', 'TRADEMARK', 'DESIGN'];
    public pagination: Pagination = { page: 1, limit: 50, total: 0, total_pages: 1 };
    public loading: boolean = false;
    public detailLoading: boolean = false;
    public editing: boolean = false;
    public saving: boolean = false;
    public uploading: boolean = false;
    public uploadProgress: number = 0;
    public deletingFileId: string = '';
    public errorMessage: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public get filteredItems() {
        const query = String(this.filters.q || '').trim().toLowerCase();
        return this.items.filter((item) => {
            const queryMatched = !query || [
                item.title,
                item.application_number,
                item.registration_number,
                item.sale_request_id
            ].join(' ').toLowerCase().includes(query);
            const statusMatched = !this.filters.publication_status
                || item.publication_status === this.filters.publication_status;
            const typeMatched = !this.filters.right_type
                || item.right_type === this.filters.right_type;
            return queryMatched && statusMatched && typeMatched;
        });
    }

    public async load(resetPage: boolean = false) {
        if (this.loading || this.statusSaving) return;
        if (resetPage) this.filters.page = 1;

        const previousId = this.selected?.id || '';
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('list_market_listings', {
                page: this.filters.page,
                limit: this.filters.limit
            });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '공개매물 목록을 불러오지 못했습니다.'));
            }
            const data = response.data || {};
            this.items = Array.isArray(data.items)
                ? data.items.map((item: any) => this.normalizeListing(item))
                : [];
            this.pagination = data.pagination || {
                page: this.filters.page,
                limit: this.filters.limit,
                total: this.items.length,
                total_pages: 1
            };
            this.filters.page = this.pagination.page || 1;

            const next = previousId
                ? this.items.find((item) => item.id === previousId)
                : null;
            if (next) {
                await this.loadDetail(next.id, false);
            } else {
                this.selected = null;
                this.editing = false;
            }
        } catch (error) {
            this.items = [];
            this.selected = null;
            this.editing = false;
            this.errorMessage = this.errorText(error, '공개매물 목록을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadDetail(id: string, render: boolean = true) {
        if (!id || this.detailLoading || this.statusSaving) return;
        this.detailLoading = true;
        this.errorMessage = '';
        this.editing = false;
        if (render) await this.service.render();
        try {
            const response = await wiz.call('get_market_listing', { id });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '공개매물 상세를 불러오지 못했습니다.'));
            }
            this.applyDetail(response.data || {});
            this.updateListItem(this.selected);
        } catch (error) {
            this.selected = null;
            this.errorMessage = this.errorText(error, '공개매물 상세를 불러오지 못했습니다.');
            if (render) await this.service.modal.error(this.errorMessage);
        } finally {
            this.detailLoading = false;
            if (render) await this.service.render();
        }
    }

    public async closeDetail() {
        if (this.detailLoading || this.saving || this.statusSaving || this.uploading || this.deletingFileId) return;
        this.selected = null;
        this.editing = false;
        this.statusDraft = '';
        await this.service.render();
    }

    public async startEdit() {
        if (!this.selected || this.saving || this.statusSaving) return;
        this.editDraft = this.draftFromDetail(this.selected.source_request);
        this.editing = true;
        await this.service.render();
    }

    public async cancelEdit() {
        if (!this.selected || this.saving || this.statusSaving) return;
        this.editDraft = this.draftFromDetail(this.selected.source_request);
        this.editing = false;
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.selected || !this.editing || this.saving || this.statusSaving) return;
        if (!this.editDraft.right.right_title.trim()) {
            await this.service.modal.error('매물명을 입력해주세요.');
            return;
        }
        if (!this.editDraft.right.right_type.trim()) {
            await this.service.modal.error('권리구분을 선택해주세요.');
            return;
        }
        if (!this.editDraft.seller.name.trim()) {
            await this.service.modal.error('판매자명을 입력해주세요.');
            return;
        }

        const id = this.selected.id;
        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('update_market_listing', {
                id,
                payload: JSON.stringify(this.editDraft)
            });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '공개매물 저장에 실패했습니다.'));
            }
            const publishedRefreshed = !!response.data?.published_refreshed;
            await this.loadDetail(id, false);
            this.editing = false;
            await this.service.modal.success(
                publishedRefreshed
                    ? '매물 정보를 저장하고 공개 내용을 갱신했습니다.'
                    : '매물 정보를 저장했습니다.'
            );
        } catch (error) {
            this.errorMessage = this.errorText(error, '공개매물 저장에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async saveStatus() {
        if (!this.selected || this.statusSaving || this.saving || this.uploading
            || this.deletingFileId || this.detailLoading || this.loading || this.editing) return;
        if (!this.publicationStatuses.includes(this.statusDraft)) {
            await this.service.modal.error('게시상태를 선택해주세요.');
            return;
        }
        if (this.statusDraft === this.selected.publication_status) return;

        const id = this.selected.id;
        const status = this.statusDraft;
        this.statusSaving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('update_market_listing_status', { id, status });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '게시상태를 저장하지 못했습니다.'));
            }
            this.applyDetail(response.data || {});
            this.updateListItem(this.selected);
            await this.service.modal.success('게시상태를 ' + this.publicationLabel(status) + '(으)로 저장했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '게시상태를 저장하지 못했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.statusSaving = false;
            await this.service.render();
        }
    }

    public async uploadDocuments(event: any) {
        const input = event?.target as HTMLInputElement;
        const files = input?.files ? Array.from(input.files) as File[] : [];
        if (input) input.value = '';
        if (!this.selected || !files.length || this.uploading || this.statusSaving) return;

        for (const file of files) {
            const validation = this.validateDocument(file);
            if (validation) {
                await this.service.modal.error(validation);
                return;
            }
        }

        const id = this.selected.id;
        this.uploading = true;
        this.uploadProgress = 0;
        this.errorMessage = '';
        await this.service.render();
        try {
            for (let index = 0; index < files.length; index += 1) {
                const form = new FormData();
                form.append('id', id);
                form.append('file', files[index]);
                const response: any = await this.service.file.upload(
                    wiz.url('upload_market_listing_file'),
                    form,
                    async (percent: number) => {
                        this.uploadProgress = Math.round(
                            ((index + percent / 100) / files.length) * 100
                        );
                        await this.service.render();
                    }
                );
                this.uploadResponseData(response);
            }
            await this.loadDetail(id, false);
            await this.service.modal.success(files.length + '개 서류를 탑재했습니다.');
        } catch (error) {
            this.errorMessage = this.uploadErrorText(error, '서류 탑재에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.uploading = false;
            this.uploadProgress = 0;
            await this.service.render();
        }
    }

    public async deleteDocument(file: SaleFile) {
        if (!this.selected || !file?.id || this.deletingFileId || this.statusSaving) return;
        const confirmed = await this.service.modal.show({
            title: '공개매물 서류 삭제',
            message: (file.file_name || '선택한 서류') + '을(를) 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.deletingFileId = file.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('delete_market_listing_file', {
                id,
                file_id: file.id
            });
            if (response.code !== 200 && response.code !== 204) {
                throw new Error(this.responseError(response, '서류 삭제에 실패했습니다.'));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success('탑재 서류를 삭제했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '서류 삭제에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.deletingFileId = '';
            await this.service.render();
        }
    }

    public async previousPage() {
        if (this.filters.page <= 1 || this.loading || this.statusSaving) return;
        this.filters.page -= 1;
        await this.load();
    }

    public async nextPage() {
        if (this.filters.page >= this.pagination.total_pages || this.loading || this.statusSaving) return;
        this.filters.page += 1;
        await this.load();
    }

    public publicationLabel(value: string) {
        const labels: any = {
            PUBLISHED: '공개중',
            SUSPENDED: '판매진행중',
            ENDED: '판매완료',
            UNPUBLISHED: '비공개',
            WITHDRAWN: '게시철회'
        };
        return labels[value] || value || '-';
    }

    public publicationClass(value: string) {
        const classes: any = {
            PUBLISHED: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            SUSPENDED: 'border-amber-200 bg-amber-50 text-amber-700',
            ENDED: 'border-slate-200 bg-slate-100 text-slate-600',
            UNPUBLISHED: 'border-slate-200 bg-slate-50 text-slate-600',
            WITHDRAWN: 'border-rose-200 bg-rose-50 text-rose-700'
        };
        return classes[value] || 'border-slate-200 bg-slate-50 text-slate-600';
    }

    public transactionLabel(value: string) {
        const labels: any = {
            AVAILABLE: '거래가능',
            IN_TRANSACTION: '판매진행중',
            COMPLETED: '판매완료',
            CANCELLED: '거래취소'
        };
        return labels[value] || value || '-';
    }

    public transactionClass(value: string) {
        const classes: any = {
            AVAILABLE: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            IN_TRANSACTION: 'border-amber-200 bg-amber-50 text-amber-700',
            COMPLETED: 'border-slate-200 bg-slate-100 text-slate-600',
            CANCELLED: 'border-rose-200 bg-rose-50 text-rose-700'
        };
        return classes[value] || 'border-slate-200 bg-slate-50 text-slate-600';
    }

    public rightTypeLabel(value: string) {
        const labels: any = {
            PATENT: '특허',
            UTILITY_MODEL: '실용신안',
            TRADEMARK: '상표',
            DESIGN: '디자인'
        };
        return labels[value] || value || '-';
    }

    public sellerLabel(value: string) {
        const labels: any = {
            INDIVIDUAL: '개인 판매자',
            COMPANY: '기업 판매자',
            PATENT_OFFICE: '특허사무소',
            UNDISCLOSED: '판매자 비공개'
        };
        return labels[value] || value || '-';
    }

    public money(value: number | null) {
        if (value === null || value === undefined) return '-';
        return new Intl.NumberFormat('ko-KR', {
            style: 'currency',
            currency: 'KRW',
            maximumFractionDigits: 0
        }).format(value);
    }

    public fileSize(value: number) {
        const size = Number(value || 0);
        if (!size) return '0 B';
        if (size < 1024) return size + ' B';
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    private emptyDraft(): ListingEditDraft {
        return {
            seller: { name: '', company: '', office_name: '', phone: '', email: '' },
            right: {
                right_type: '',
                category: '',
                field: '',
                right_title: '',
                owner_name: '',
                application_number: '',
                application_date: '',
                registration_number: '',
                registration_date: ''
            },
            desired_price: null,
            sale_method: '',
            privacy_consent: false,
            fee_consent: false,
            admin_service_requested: false,
            description: ''
        };
    }

    private normalizeListing(item: any): ListingItem {
        const snapshot = item?.snapshot || item?.current_snapshot || {};
        const right = item?.right || {};
        const publicationStatus = String(item?.status || item?.publication_status || 'UNPUBLISHED').toUpperCase();
        const transactionFallback = publicationStatus === 'SUSPENDED' ? 'IN_TRANSACTION'
            : publicationStatus === 'ENDED' ? 'COMPLETED' : 'AVAILABLE';
        return {
            id: item?.id || '',
            sale_request_id: item?.sale_request_id || '',
            title: item?.title
                || snapshot.title
                || right.right_title
                || right.title
                || '',
            right_type: item?.right_type || snapshot.right_type || right.right_type || '',
            application_number: item?.application_number
                || snapshot.application_number
                || right.application_number
                || '',
            registration_number: item?.registration_number
                || snapshot.registration_number
                || right.registration_number
                || '',
            asking_price: item?.asking_price
                ?? snapshot.asking_price
                ?? item?.desired_price
                ?? item?.price?.amount
                ?? null,
            publication_status: publicationStatus,
            transaction_status: String(
                item?.transaction_status || item?.sale_status || transactionFallback
            ).toUpperCase(),
            public_seller_label: item?.public_seller_label
                || snapshot.public_seller_label
                || '',
            updated_at: item?.updated_at || snapshot.updated_at || ''
        };
    }

    private normalizeSaleRequest(detail: any): SaleRequestDetail {
        const right = detail?.right || {};
        const agreements = detail?.agreements || {};
        const price = detail?.price || {};
        return {
            ...detail,
            seller: {
                ...this.emptyDraft().seller,
                ...(detail?.seller || {})
            },
            right: {
                ...this.emptyDraft().right,
                ...right,
                right_title: right.right_title || right.title || detail?.title || '',
                application_number: right.application_number
                    || detail?.application_number
                    || '',
                application_date: right.application_date
                    || detail?.application_date
                    || '',
                registration_number: right.registration_number
                    || detail?.registration_number
                    || '',
                registration_date: right.registration_date
                    || detail?.registration_date
                    || ''
            },
            desired_price: detail?.desired_price ?? price.amount ?? null,
            privacy_consent: detail?.privacy_consent ?? agreements.privacy ?? false,
            fee_consent: detail?.fee_consent ?? agreements.fee ?? false,
            admin_service_requested: detail?.admin_service_requested ?? false,
            description: detail?.description || detail?.summary || '',
            files: Array.isArray(detail?.files)
                ? detail.files.map((file: any) => ({
                    ...file,
                    file_name: file.file_name || file.name || '',
                    file_type: file.file_type || file.type || 'DOCUMENT',
                    mime_type: file.mime_type || file.content_type || '',
                    size_bytes: file.size_bytes ?? file.size ?? 0,
                    created_at: file.created_at || file.uploaded_at || '',
                    download_url: file.download_url || file.url || ''
                }))
                : []
        } as SaleRequestDetail;
    }

    private draftFromDetail(detail: SaleRequestDetail): ListingEditDraft {
        return {
            seller: { ...this.emptyDraft().seller, ...(detail.seller || {}) },
            right: { ...this.emptyDraft().right, ...(detail.right || {}) },
            desired_price: detail.desired_price,
            sale_method: detail.sale_method || '',
            privacy_consent: !!detail.privacy_consent,
            fee_consent: !!detail.fee_consent,
            admin_service_requested: !!detail.admin_service_requested,
            description: detail.description || ''
        };
    }

    private applyDetail(data: any) {
        const listing = this.normalizeListing(data?.listing || {});
        const sourceRequest = this.normalizeSaleRequest(data?.sale_request || {});
        if (!listing.title) listing.title = sourceRequest.right.right_title;
        if (!listing.right_type) listing.right_type = sourceRequest.right.right_type;
        if (!listing.application_number) {
            listing.application_number = sourceRequest.right.application_number;
        }
        if (!listing.registration_number) {
            listing.registration_number = sourceRequest.right.registration_number;
        }
        if (listing.asking_price === null) listing.asking_price = sourceRequest.desired_price;
        this.selected = {
            ...listing,
            source_request: sourceRequest
        };
        this.editDraft = this.draftFromDetail(sourceRequest);
        this.statusDraft = this.selected.publication_status;
    }

    private updateListItem(detail: ListingDetail | null) {
        if (!detail) return;
        const index = this.items.findIndex((item) => item.id === detail.id);
        if (index < 0) return;
        this.items[index] = {
            id: detail.id,
            sale_request_id: detail.sale_request_id,
            title: detail.title,
            right_type: detail.right_type,
            application_number: detail.application_number,
            registration_number: detail.registration_number,
            asking_price: detail.asking_price,
            publication_status: detail.publication_status,
            transaction_status: detail.transaction_status,
            public_seller_label: detail.public_seller_label,
            updated_at: detail.updated_at
        };
    }

    private validateDocument(file: File) {
        const allowed = ['pdf', 'jpg', 'jpeg', 'png', 'hwp', 'hwpx', 'doc', 'docx', 'xls', 'xlsx'];
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        if (!allowed.includes(extension)) {
            return 'PDF, 이미지, HWP, Word 또는 Excel 서류만 탑재할 수 있습니다.';
        }
        if (!file.size) return '빈 서류는 탑재할 수 없습니다.';
        if (file.size > 20 * 1024 * 1024) return '서류는 파일당 20MB 이하여야 합니다.';
        return '';
    }

    private uploadResponseData(response: any) {
        const payload = response?.responseJSON || response;
        const status = Number(payload?.code || response?.status || 200);
        if (!payload || status >= 400) {
            const message = payload?.data?.error?.message
                || payload?.error?.message
                || payload?.message
                || '서류 탑재에 실패했습니다.';
            throw new Error(message);
        }
        return payload.data;
    }

    private uploadErrorText(error: any, fallback: string) {
        const payload = error?.responseJSON || error;
        return payload?.data?.error?.message
            || payload?.error?.message
            || payload?.message
            || fallback;
    }

    private responseError(response: any, fallback: string) {
        const error = response?.data?.error;
        if (!error) return fallback;
        const messages: any = {
            CORE_API_PROXY_NOT_CONFIGURED: 'Core API 연동 설정이 필요합니다.',
            CORE_API_UNAVAILABLE: 'Core API에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.',
            UNAUTHORIZED: 'Core API 관리자 토큰을 확인해주세요.',
            ADMIN_AUTH_NOT_CONFIGURED: 'Core API 관리자 인증이 설정되지 않았습니다.',
            LISTING_NOT_FOUND: '선택한 공개매물을 찾을 수 없습니다.',
            INVALID_LISTING_ID: '공개매물 ID를 확인해주세요.',
            INVALID_LISTING_PAYLOAD: '저장할 매물 정보를 확인해주세요.',
            UNSUPPORTED_SALE_FILE_TYPE: '지원하지 않는 서류 형식입니다.',
            SALE_FILE_TOO_LARGE: '서류는 파일당 20MB 이하여야 합니다.'
        };
        return messages[error.code] || error.message || fallback;
    }

    private errorText(error: any, fallback: string) {
        return error instanceof Error && error.message ? error.message : fallback;
    }
}

export default PageIpMarketListingsComponent;